// extracted by mini-css-extract-plugin
export default {"island":"island--bGr2s","padding":"padding--YUQND"};